  import {
    Localization
  } from "cartovista";

var g = "onBoarding.steps.";

export var GuidedTourConfig = {
  STEPS: [
    {
      querySelector: ".cv-btnThemeSetList:not(.cv-invisible)",
      title: "Voir l’inaccessible",
      message: "C'est ici que vous pouvez basculer entre différents ensembles de données prédéfinis à afficher sur la carte et les panneaux environnants. Vous pouvez bien sûr ajouter votre propre analyse personnalisée à l'aide de notre outil d'analyse thématique personnalisée.",
    }, {
      querySelector: ".cv-bottombar",
      title: "Donnez vie à vos données",
      message: "Une fois un thème sélectionné, vous pouvez parcourir la carte et interagir avec les différents ensembles de données et graphiques qui leur sont associés. Vos données n'ont jamais été aussi interactives et faciles à naviguer.",
    }, {
      querySelector: ".cv-toolbar",
      title: "Vos données à portée de main",
      message: "Les outils de sélection vous permettent de sélectionner manuellement des entités sur la carte pour étudier leurs données. Les panneaux seront mis à jour automatiquement avec les informations relatives à votre nouvelle sélection.",
    }, {
      querySelector: "#Constat_panel_btn",
      title: "Le constat",
      message: "Description de la carte et de la thématique appliquée",
      position: "right"
    }, {
      querySelector: "#SearchView_panel_btn",
      title: "Passez en mode recherche",
      message: "Besoin d'informations sur une fonction cartographique particulière? Utilisez ce panneau pour effectuer une recherche dans les données de votre carte. Une fois que vous avez ce que vous cherchiez, sélectionnez-le et la carte mettra à jour votre vue à un niveau de zoom optimal pour que vous puissiez travailler avec votre donnée.",
      position: "right"
    }, {
      querySelector: "#Filter_panel_btn",
      title: "",
      message: "",
      position: "right"
    }, {
      querySelector: ".cv-btnHelp",
      title: "Consultez ce guide à votre guise",
      message: "Besoin d’un rappel? Initiez à nouveau le survol via l'option \"Visite guidée\" sous ce menu."
    }
]
};
